import { Stack, useTheme } from '@fti/design-system';

interface ReflectionFieldCardProps {
  label: string;
  description: string;
  value: string | null;
}

export function ReflectionFieldCard({ label, description, value }: ReflectionFieldCardProps) {
  const { theme } = useTheme();

  return (
    <Stack gap="xs">
      <span style={{ fontWeight: 600, fontSize: '0.9rem', color: theme.colors.text.primary }}>
        {label}
      </span>
      <span style={{ fontSize: '0.75rem', color: theme.colors.text.secondary }}>
        {description}
      </span>
      {value ? (
        <p style={{ fontSize: '0.85rem', color: theme.colors.text.primary, margin: 0, lineHeight: 1.6 }}>
          {value}
        </p>
      ) : (
        <p style={{ fontSize: '0.85rem', color: theme.colors.text.secondary, margin: 0, fontStyle: 'italic' }}>
          Insufficient data to assess
        </p>
      )}
    </Stack>
  );
}
